module.exports = __webpack_public_path__ + "public/images/Testimonial_Silas.0cc9c323bf86f0637d292a58212fb351.webp";